/** @jsxImportSource @emotion/react */
import classNames from 'classnames';
import React from 'react';
import { SingleValue } from 'react-select';
import { SelectOption, UDSelect } from 'ud-form/components/select/component';
import Label from 'ud-ui/components/label';
import { DivProps } from '../../../../../typings';
import overrideSelectComponents from '../../../../ud-form/components/select/component/override';
import * as S from '../../../../ud-form/components/select/component/styles';
import UDText from '../../../../ud-ui/components/text';
import { MainBlock, stylesOptions } from './styles';

type IProps = Omit<DivProps, 'onChange'> & {
  headerText: string;
  onChange?: (value: { label: string | number | JSX.Element; value: string } | undefined) => void;
  options: { label: string; value: string }[];
  value?: { label: string; value: string };
  disable?: boolean;
};

function Select(props: IProps) {
  const { headerText, options, value, onChange, disable, ...rest } = props;

  const onChangeComponent = (newValue: SingleValue<SelectOption<string, string>>) => {
    if (!onChange) {
      return;
    }
    if (!newValue) {
      return;
    }
    onChange({ label: newValue.label, value: newValue.value });
  };

  const changedStyles = { ...overrideSelectComponents };
  changedStyles.Option = (props: any) => {
    const className = classNames('flex items-center justify-between px-4', props.isMulti ? 'py-1' : 'py-2');

    return (
      <S.Option css={stylesOptions} {...props.innerProps} className={className}>
        <UDText type="subhead">{props.children}</UDText>
        {props.isMulti && <S.OptionCheckbox data-checked={props.isSelected} />}
      </S.Option>
    );
  };

  return (
    <MainBlock {...rest}>
      <Label text={headerText}>
        <UDSelect
          isDisabled={disable}
          isMulti={false}
          options={options}
          value={value}
          onChange={onChangeComponent}
          components={changedStyles}
        />
      </Label>
    </MainBlock>
  );
}

export default Select;
